var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 8C25 7.44772 24.5523 7 24 7H19V2C19 1.44772 18.5523 1 18 1H14C13.4477 1 13 1.44772 13 2V7H8C7.44772 7 7 7.44772 7 8V12C7 12.5523 7.44772 13 8 13H13V18C13 18.5523 13.4477 19 14 19H18C18.5523 19 19 18.5523 19 18V13H24C24.5523 13 25 12.5523 25 12V8Z",
    stroke: "#448B7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 31L2.31467 27.8253C1.46364 26.7614 1 25.4396 1 24.0773V17.1826C1 16.078 1.89543 15.1826 3 15.1826V15.1826C4.10457 15.1826 5 16.078 5 17.1826V22.1826",
    stroke: "#3F2C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 30.9999V26.9999C11.0006 25.8135 10.6493 24.6535 9.99071 23.6666L8.46805 21.3866C8.20439 20.9499 7.7735 20.6401 7.27556 20.5293C6.77762 20.4185 6.25603 20.5163 5.83205 20.7999V20.7999C5.05235 21.3223 4.78178 22.3424 5.20005 23.1826L7.00271 26.1826",
    stroke: "#3F2C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 31L29.6853 27.8253C30.5364 26.7614 31 25.4396 31 24.0773V17.1826C31 16.078 30.1046 15.1826 29 15.1826V15.1826C27.8954 15.1826 27 16.078 27 17.1826V22.1826",
    stroke: "#3F2C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30.9999V26.9999C20.9995 25.8134 21.3507 24.6534 22.0093 23.6665L23.532 21.3839C23.7948 20.9463 24.2253 20.6354 24.7233 20.5236C25.2213 20.4117 25.7434 20.5087 26.168 20.7919V20.7919C26.9515 21.3139 27.2236 22.3377 26.8027 23.1799L25 26.1799",
    stroke: "#3F2C26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceHands);
export default __webpack_public_path__ + "static/media/insurance-hands.a7a87de1e8dd58013e3f3129343a481e.svg";
export { ForwardRef as ReactComponent };